export const getAnalysesEventsData = state => state.events.analysesEvents;
export const analysesEventsIsFetching = state => state.events.loading.analysesEvents;
export const getTasksEventsData = state => state.events.tasksEvents;
export const taskEventsIsFetching = state => state.events.loading.tasksEvents;